AOS.init({
   duration: 1200,
})

$('.bnn_slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   infinite: true,
   autoplay: true,
   autoplaySpeed: 1500,
   arrows: false,
   dots: true,
   adaptiveHeight: true,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});


$('.fea_cat_slider').slick({
   slidesToShow: 5,
   slidesToScroll: 1,
   infinite: true,
   autoplay: false,
   autoplaySpeed: 1500,
   dots: false,
   prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
   nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-arrow-left"></i></button>',
   adaptiveHeight: true,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});

$('.cat_fea_cat_slider').slick({
   slidesToShow: 6,
   slidesToScroll: 1,
   infinite: true,
   autoplay: false,
   autoplaySpeed: 1500,
   dots: false,
   prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-arrow-left"></i></button>',
   nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-arrow-left"></i></button>',
   adaptiveHeight: true,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});


$('.collection_slider').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   infinite: true,
   autoplay: true,
   autoplaySpeed: 1500,
   arrows: false,
   dots: false,
   adaptiveHeight: true,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});


$('.rev_slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   infinite: true,
   autoplay: true,
   autoplaySpeed: 1500,
   arrows: false,
   dots: true,
   adaptiveHeight: true,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});


$(document).ready(function(){

  $('.product-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.product-thumbs'
  });

  $('.product-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-main',
    dots: false,
    focusOnSelect: true,
    vertical: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          slidesToShow: 4
        }
      }
    ]
  });

});


// Back to top
// Show/Hide Button on Scroll
$(window).scroll(function () {
  if ($(this).scrollTop() > 200) { // Show after 200px scroll
    $('.back-to-top').fadeIn();
  } else {
    $('.back-to-top').fadeOut();
  }
});

// Smooth Scroll to Top
$('.back-to-top').click(function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, 600); // 600ms scroll speed
});



$('.coff_per').each(function() {
  if ($.trim($(this).text()) === '') {
    $(this).hide();
  } else {
    $(this).show();
  }
});
$('.coff_new').each(function() {
  if ($.trim($(this).text()) === '') {
    $(this).hide();
  } else {
    $(this).show();
  }
});


  document.getElementById('shippingZip')?.addEventListener('change', function () {
    localStorage.setItem('shipping_zip', this.value);
  });
  document.getElementById('shippingCountry')?.addEventListener('change', function () {
    localStorage.setItem('shipping_country', this.value);
  });


document.getElementById("filt_toggle").addEventListener("click", function () {

  // Apply only on mobile screens
  if (window.innerWidth <= 767) {
    const sidebar = document.querySelector(".filter-sidebar");

    if (sidebar.style.display === "none" || sidebar.style.display === "") {
      sidebar.style.display = "block";
    } else {
      sidebar.style.display = "none";
    }
  }

});
/* ===========================
   CUSTOM PRICE FILTER SCRIPT
   =========================== */

fetch(window.location.pathname + '?view=all-products-json')
  .then(res => res.json())
  .then(products => {
      console.log('Loaded full collection:', products);
  });


